import "../../style/scss/App.scss";

function LocationListItem({ location, onEdit }) {
  const loc = location || {};
  return (
    <li key={loc.ID}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`location-list-item-${loc.ID}`}
        onClick={() => onEdit?.(loc.ID)}
      >
        <div className="Job mobilePanel">
          <span className="title">{loc.Name || "Location name not specified"}</span>
          <span className="byline">
            {loc.CityName}, {loc.StateName}, {loc.CountryName}
          </span>
          <span className="rightText"></span>
        </div>
      </button>
    </li>
  );
}

export default LocationListItem;
